export { App as default } from "@website/widget/pages/_app";
